import React from 'react';
import { default as CMLogin } from 'cm-react/lib/services/auth/Login/LoginWithUsername';
import AuthTemplate from '../components/AuthTemplate';
import SEOMeta from '../components/SEOMeta';
import i18n from 'react-intl-universal';

export const Login = props => (
  <AuthTemplate>
    <SEOMeta title={i18n.get('app.auth.loginForm.title')} />
    <CMLogin {...props} />
  </AuthTemplate>
);
